/* eslint-disable max-len */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decodeHtmlEntities',
})
export class DecodeHtmlEntitiesPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    if (value) {
      const checkValue = value.search('T&eacute;l&eacute;charger');
      if (checkValue > -1) {
        return 'Télécharger les numéros';
      } else {
        const translateRe = /&(nbsp|amp|quot|lt|gt|agrave|acirc|ccedil|egrave|eacute|ecirc|euml|icirc|iuml|ocirc|oelig|ugrave|ucirc|uuml|yuml);/g;
        const translate = {
          nbsp: ' ',
          amp: '&',
          quot: '"',
          lt: '<',
          gt: '>',
          agrave: 'à',
          acirc: 'â',
          ccedil: 'ç',
          egrave: 'è',
          eacute: 'é',
          ecirc: 'ê',
          euml: 'ë',
          icirc: 'î',
          iuml: 'ï',
          ocirc: 'ô',
          oelig: 'œ',
          ugrave: 'ù',
          ucirc: 'û',
          uuml: 'ü',
          yuml: 'ÿ',
        };
        return value.replace(translateRe,  (match, entity) => translate[entity]);
      }
    }
  }
}
